import React, { useCallback, useEffect, useState } from "react";
import { ActiveFilters, Filter, SortDrawer } from "@app/components/SortDrawer";
import { EVENT_FILTER_UPDATE, EVENT_SCHOOL_COUNT_UPDATE, INITIAL_ACTIVE_FILTERS } from "@app/components/pageCollections/school-list";

interface DrawerWrapperProps {
  initialTotalResults?: number;
  filters: Filter[];
  initialActiveFilters: ActiveFilters[];
  onFilterUpdate: (activeFilters: ActiveFilters[]) => void;
}

export const DrawerWrapper = ({ initialTotalResults, filters, initialActiveFilters, onFilterUpdate }: DrawerWrapperProps) => {
  const [activeFilters, setActiveFilters] = useState(initialActiveFilters);
  const [totalResults, setTotalResults] = useState(initialTotalResults);

  useEffect(() => {
    const onActiveFiltersChange = (e: any) => {
      setActiveFilters([...e.detail.activeFilters]);
    };

    const onUpdateSchoolCount = (e: any) => {
      setTotalResults(e.detail.count);
    };

    document.addEventListener(EVENT_FILTER_UPDATE, onActiveFiltersChange);
    document.addEventListener(EVENT_SCHOOL_COUNT_UPDATE, onUpdateSchoolCount);
    return () => {
      document.removeEventListener(EVENT_FILTER_UPDATE, onActiveFiltersChange);
      document.removeEventListener(EVENT_SCHOOL_COUNT_UPDATE, onUpdateSchoolCount);
    };
  }, []);

  const onClear = useCallback(() => {
    setActiveFilters([...INITIAL_ACTIVE_FILTERS]);
    onFilterUpdate?.([...INITIAL_ACTIVE_FILTERS]);
  }, []);

  return (
    <>
      <SortDrawer
        totalResults={totalResults}
        filters={filters}
        activeFilters={activeFilters}
        onFilterUpdate={onFilterUpdate}
        onClear={onClear}
      />
    </>
  );
};
